exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.wait_data[data-v-de8da87e] {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100vw;\n  height: 100vh;\n  background-color: #000;\n  z-index: 100000;\n  opacity: .8;\n  -webkit-transition: opacity .15s linear;\n  transition: opacity .15s linear;\n}\n", ""]);

// exports
